<div class="search-filter-container" [class.show-search]="isActive">
  <div class="category-cont"  #dropdown (click)="!isOpened ? toggleCalendar() : undefined">
    <div class="select-type select input-field" [class.opened]="isOpened" >
      <img src="assets/icons/new/calendar.svg" alt="calendar" class="calendar-icon">

      <span class="selected-value">
        @if (shouldShowSelectedRange) {
          <span class="date-value">
            {{ rangeText }}
          </span>
        } @else {
          <span fiTranslation="REQUEST_OVERVIEW_FILTER_DATE_VALUE"></span>
        }
      </span>


      @if (hasSelectedRange && !isMobile && showSelectedRange) {
        <span class="action-slot" (click)="deleteDate(); $event.stopPropagation();">
          <mat-icon class="close">close</mat-icon>
        </span>
      }

      <div class="options-cont" [ngStyle]="containerStyle">
        <div class="select-form date-form">
          <fi-date-time
            #calendar
            [positionAnchor]="dropdown"
            [absolutePositioning]="!isMobile"
            [dateRangeToDisplay]="range"
            [emitUpdateRangeOnlyWhenToggled]="false"
            [showClearButton]="true"
            [transparentOverlay]="!isMobile"
            [showRangeOptions]="true"
            [enableRecurring]="false"
            [withHours]="false"
            (dateRangeSelected)="onRangeSelect($event)"
            selectMode="range">
          </fi-date-time>
        </div>
      </div>
    </div>
  </div>

</div>
